import {$getRoot, $isParagraphNode, LexicalEditor} from 'lexical';
import {$generateHtmlFromNodes} from '@lexical/html';
import DOMPurify from 'dompurify';
import {sanitizeConfig} from './consts';

export const modifyHtmlList = (htmlString: string, isRTL: boolean) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    // We need to force the list item direction to match the behavior of the old editor.
    const dir = isRTL ? 'rtl' : 'ltr';
    doc.querySelectorAll('ol, ul').forEach(el => {
        (el as HTMLElement).style.textAlign = isRTL ? 'right' : 'left';
        el.setAttribute('dir', dir);

        const children = el.getElementsByTagName('li');
        if (children.length > 0) {
            Array.from(children).forEach(child => {
                child.setAttribute('dir', dir);
            });
        }
    });

    return doc.body.innerHTML;
};

const isEditorEmpty = (editor: LexicalEditor) =>
    editor.getEditorState().read(() => {
        const root = $getRoot();
        const children = root.getChildren();

        if (children.length !== 1) return false;

        const firstChild = children[0];
        if (!$isParagraphNode(firstChild)) return false;

        return (
            firstChild.getChildren().length === 0 ||
            (firstChild.getChildren().length === 1 &&
                firstChild.getFirstChild()?.getType() === 'linebreak')
        );
    });

export const getHtmlContent = async (
    editor: LexicalEditor,
    callback?: (html: string) => void,
    isRTL = false
): Promise<string> => {
    return new Promise((resolve, reject) => {
        if (!editor) {
            reject('Editor instance is missing');
        }
        editor.getEditorState().read(() => {
            const isEmpty = isEditorEmpty(editor);
            const res = isEmpty
                ? ''
                : DOMPurify.sanitize($generateHtmlFromNodes(editor), sanitizeConfig);

            const validatedHTML = res ? modifyHtmlList(res, isRTL) : '';
            if (callback) {
                callback(validatedHTML);
            }

            resolve(validatedHTML);
        });
    });
};
